import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { black500 } from '@ui/constants/color';
import { palette } from '../../../../theme/palette';
const theme = palette('light');
export const QNumericInput = ({ label, placeholder, onChange, mt = 0, disabled = false, fillBackground = true, value = '', insidLabel, errormsg, thousandSeparator = '.', decimalSeparator = ',', allowNegative = false, decimalScale = 2, fixedDecimalScale = true, onValueChange, }) => {
    const [inputValue, setInputValue] = useState(value);
    const [showTypography, setShowTypography] = useState(false);
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    const handleInputChange = (values) => {
        const { value } = values;
        setInputValue(value);
        if (onChange) {
            onChange(value);
        }
        setShowTypography(value !== '');
        if (onValueChange) {
            onValueChange(values);
        }
    };
    const handleInputFocus = () => {
        setShowTypography(true);
    };
    const handleInputBlur = () => {
        setShowTypography(inputValue !== '');
    };
    return (_jsxs(Box, { mt: mt, width: '100%', sx: {
            position: 'relative'
        }, children: [label && (_jsx(Typography, { variant: 'subtitle2', color: black500, children: label })), _jsx(NumericFormat, { customInput: TextField, value: inputValue, onValueChange: handleInputChange, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator, allowNegative: allowNegative, decimalScale: decimalScale, fixedDecimalScale: fixedDecimalScale, onFocus: handleInputFocus, onBlur: handleInputBlur, disabled: disabled, placeholder: showTypography ? '' : placeholder, sx: {
                    mt: label ? '2px' : '0px',
                    background: '#F8F8F8',
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: fillBackground ? '#F8F8F8' : theme.common.white,
                        border: 'none',
                        borderRadius: '25px',
                        '& fieldset': {
                            border: 'none'
                        },
                        '&.Mui-focused fieldset': {
                            border: 'none'
                        },
                        '&.Mui-disabled': {
                            borderRadius: '25px',
                        }
                    }
                }, variant: 'outlined', fullWidth: true, InputLabelProps: { shrink: false } }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: -19, left: 0 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, ml: 2, color: '#FF0000', children: errormsg }) })), showTypography && insidLabel && (_jsx(Box, { sx: { position: 'absolute', top: 6, left: 16 }, children: _jsx(Typography, { fontSize: '8px', fontWeight: 500, color: '#B1B1B1', children: insidLabel }) }))] }));
};
